<template>
    <div :class="'row' + (this.error ? ' has-error' : '')">
        <slot></slot>
        <span class="help-block" v-if="error">{{ error }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            error: {
                type: String,
                default: ''
            },
        }
    }
</script>

<style lang="scss" scoped>
    .help-block {
        padding: 0 0 20px 15px;
    }
</style>